export default interface InvoiceMirror {
    id: number;
    accno: string;
    dim1: string;
    dim2: string;
    dim3: string;
    dim4: string;
    dim5: string;
    dim6: string;
    dim7: string;
    dim8: string;
    dim9: string;
    dim10: string;
    dim11: string;
    dim12: string;
}

export const InvoiceMirrorDefaultProps: InvoiceMirror = {
    id: 1,
    accno: "-",
    dim1: "",
    dim2: "",
    dim3: "",
    dim4: "",
    dim5: "",
    dim6: "",
    dim7: "",
    dim8: "",
    dim9: "",
    dim10: "",
    dim11: "",
    dim12: "",

};